function setRootFontSizeByLandscape() {
  const rootHtml = document.documentElement;
  const rootWidth = rootHtml.clientWidth;
  const rootHeight = rootHtml.clientHeight;
  let k = 750;
  if (rootWidth > rootHeight) {
    k = 1920;
  }
  const rem = rootWidth / k;
  rootHtml.style.fontSize = `${rem}px`;
}
function setRootFontSizeByUA() {
  const rootHtml = document.documentElement;
  let k = 750;
  if (
    /(iPhone|iPad|iPod|iOS|Android|Windows Phone|BlackBerry|SymbianOS)/i.test(
      navigator.userAgent
    )
  ) {
    k = 750;
  } else {
    if (window.location.href.indexOf("down") > -1) {
      k = 2500;
    } else {
      k = 1920;
    }
  }
  rootHtml.style.fontSize = (rootHtml.clientWidth / k) * 100 + "px";
}
let currentType = "";
const setRootFontSize = {
  landscape: setRootFontSizeByLandscape,
  UA: setRootFontSizeByUA,
};
export function initSetRootFontSize() {
  const curFunc = setRootFontSize.UA;
  curFunc();
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", curFunc);
  }
  if (window.addEventListener) {
    window.addEventListener("load", curFunc);
    window.addEventListener("resize", curFunc);
  }
  currentType = "UA";
}
export function changeRootFontSize(type) {
  if (currentType === type) {
    return;
  }
  if (currentType) {
    const lastFunc = setRootFontSize[currentType];
    if (document.removeEventListener) {
      document.removeEventListener("DOMContentLoaded", lastFunc);
    }
    if (window.removeEventListener) {
      window.removeEventListener("load", lastFunc);
      window.removeEventListener("resize", lastFunc);
    }
  }
  const curFunc = setRootFontSize[type];
  curFunc();
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", curFunc);
  }
  if (window.addEventListener) {
    window.addEventListener("load", curFunc);
    window.addEventListener("resize", curFunc);
  }
  currentType = type;
}
